import { render, staticRenderFns } from "./addAgency.vue?vue&type=template&id=b054ffaa&scoped=true"
import script from "./addAgency.vue?vue&type=script&lang=js"
export * from "./addAgency.vue?vue&type=script&lang=js"
import style0 from "./addAgency.vue?vue&type=style&index=0&id=b054ffaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b054ffaa",
  null
  
)

export default component.exports